// Haupt-Tab ↔ Route. Der Haupt-Tab ist ein SPIEGEL der Route: `useTabStore.activeMainTab` liest
// `currentMainTab` und navigiert beim Schreiben. Ohne gebundenen Router (Unit-Tests, die nur Stores
// prüfen) setzt `navigateToMainTab` den Ref direkt. Bewusst ohne `.vue`-Import – Stores dürfen
// keine Komponenten ziehen, und Vitest lädt kein Vue-Plugin.

import {ref, readonly} from 'vue';
import type {RouteLocationNormalized, Router} from 'vue-router';

export type MainTab = 'convert' | 'history' | 'keyboard' | 'chords' | 'settings';

declare module 'vue-router' {
    interface RouteMeta {
        /** Zu welchem Haupt-Tab die Route gehört (Kind-Routen teilen ihn, z. B. /harmonika/bass). */
        mainTab?: MainTab;
        /** Zusätzliche Klassen der Tab-Fläche in App.vue. */
        paneClass?: string;
    }
}

const current = ref<MainTab>('convert');
let boundRouter: Router | null = null;

export const currentMainTab = readonly(current);

export function mainTabOf(route: Pick<RouteLocationNormalized, 'meta'>): MainTab | null {
    return route.meta.mainTab ?? null;
}

export function bindMainTabRouter(router: Router): void {
    boundRouter = router;
    current.value = mainTabOf(router.currentRoute.value) ?? current.value;
    router.afterEach((to) => {
        const tab = mainTabOf(to);
        if (tab) current.value = tab;
    });
}

export function navigateToMainTab(tab: MainTab): void {
    if (!boundRouter) {
        current.value = tab;
        return;
    }
    // Schon im Tab (auch auf einer Kind-Route wie /harmonika/bass): nicht auf die Wurzel springen.
    if (current.value === tab) return;
    // Die Wurzel-Route eines Haupt-Tabs heißt wie der Tab (router/routes.ts).
    void boundRouter.push({name: tab});
}
